import script from "./WaterBillsViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./WaterBillsViewer.vue?vue&type=script&setup=true&lang=js"

import "./WaterBillsViewer.vue?vue&type=style&index=0&id=5843a720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5843a720"]])

export default __exports__